import { createContext } from 'react';

/**
 * Account-skin feature flags (from the active account's SkinTypeDef ChannelInfo — see
 * SkinChannelInfo) that deep Clients components need without prop-drilling through every
 * intermediate view. Provided by ProGroupsShell once the skin resolves; defaults to everything
 * off, so a component rendered outside the shell (or before the skin has loaded) keeps the
 * default behavior.
 */
export interface SkinFeatures {
  /** ChannelInfo 'enablereportpdf' — PDF action lives in the ReportView header instead of the Clients report columns. */
  enableReportPdf: boolean;
}

export const DEFAULT_SKIN_FEATURES: SkinFeatures = { enableReportPdf: false };

export const SkinFeaturesContext = createContext<SkinFeatures>(DEFAULT_SKIN_FEATURES);
